<template>
  <ul v-if="!quantityOnly" class="mb-auto overflow-y-auto px-2.5">
    <li
      v-for="index in itemCount"
      :key="`skeleton-item-${index}`"
      class="border-light-charcoal-0.3 mb-4 flex items-center justify-between border-b pb-4"
    >
      <div class="flex w-full items-center">
        <div class="bg-light-charcoal-0.3 mr-4 aspect-square size-[106px] animate-pulse rounded" />
        <div class="flex grow-1 flex-col gap-y-2.5">
          <div class="flex items-center justify-between">
            <div class="bg-light-charcoal-0.3 h-4 w-32 animate-pulse rounded" />
          </div>
          <div class="bg-light-charcoal-0.3 h-4 w-24 animate-pulse rounded" />
          <div class="bg-light-charcoal-0.3 h-4 w-20 animate-pulse rounded" />
          <div class="flex items-center justify-between">
            <div
              class="border-stroke flex min-h-[34px] min-w-[100px] items-center justify-around rounded-[20px] border"
            >
              <div class="bg-light-charcoal-0.3 h-4 w-4 animate-pulse rounded" />
              <div class="bg-light-charcoal-0.3 h-4 w-4 animate-pulse rounded" />
              <div class="bg-light-charcoal-0.3 h-4 w-4 animate-pulse rounded" />
            </div>
          </div>
        </div>
        <div class="flex h-[112px] flex-col items-end gap-y-1">
          <div class="bg-light-charcoal-0.3 h-5 w-12 animate-pulse rounded" />
          <div class="bg-light-charcoal-0.3 h-3 w-16 animate-pulse rounded" />
          <div class="bg-light-charcoal-0.3 mt-auto size-8 animate-pulse rounded-full" />
        </div>
      </div>
    </li>
  </ul>
  <div v-else class="flex items-center justify-between">
    <div
      class="border-stroke flex min-h-[34px] min-w-[100px] items-center justify-around rounded-[20px] border"
    >
      <div class="bg-light-charcoal-0.3 h-4 w-4 animate-pulse rounded" />
      <div class="bg-light-charcoal-0.3 h-4 w-4 animate-pulse rounded" />
      <div class="bg-light-charcoal-0.3 h-4 w-4 animate-pulse rounded" />
    </div>
  </div>
</template>

<script setup>
const _props = defineProps({
  itemCount: {
    default: 1,
    type: Number,
  },
  quantityOnly: {
    default: false,
    type: Boolean,
  },
});
</script>
